import { regrasCalculo } from '@/service/api/endpoints/regras-calculo'
import { useStore } from '@/store'
import { useEffect, useMemo } from 'react'
import { buildNoturnoPreview } from '../utils/noturno-preview'

/**
 * Estado da prévia de adicional noturno da TabelaHorario. O índice selecionado
 * vive no store (Zustand) — não em `useState` — porque a prévia é renderizada
 * dentro do header do DataGrid, que memoiza o `renderHeader` e não o re-invoca
 * quando o índice muda. Assinantes do store re-renderizam mesmo assim, então
 * tanto o `HorariosForm` (para o cálculo) quanto o `NoturnoPreviewHeader` (para
 * exibir) leem daqui e ficam reativos.
 */
export function useNoturnoPreview() {
    const clienteId = useStore(state => state.company?.clienteId)
    const idx = useStore(state => state.noturnoIdx)
    const setIdx = useStore(state => state.setNoturnoIdx)

    const { data: regras = [] } = regrasCalculo.useFetch({
        queryParams: { clienteId },
        enabled: !!clienteId,
    })

    const { configs, defaultIndex } = useMemo(
        () => buildNoturnoPreview(regras),
        [regras],
    )

    useEffect(() => setIdx(defaultIndex), [defaultIndex, setIdx])

    return { configs, idx, setIdx, noturno: configs[idx] ?? null }
}
